import { useEffect, useMemo } from "react";
import { X2yController } from "../../../../store/x2y/types";
import * as US from "../../../../store/x2y/useSelectors";
import * as UA from "../../../../store/x2y/useActions";
import { OptionData } from "../../OptionList/types";

export const useBasicReduxHoox = (controller: X2yController) => {
  const makeUseData = () => US.createUseX2yDataAUTOFETCH(controller);
  const makeUseSubmit = () => UA.createUseSubmitX2yCallback(controller);

  const useData = useMemo(makeUseData, [controller]);
  const useSubmit = useMemo(makeUseSubmit, [controller]);

  return { useData, useSubmit };
};

export const useMultiAutofetchEffect = (
  controller: X2yController,
  options: OptionData[]
) => {
  const useFetchX2y = UA.createUseFetchX2yCallback(controller);
  const getData = useFetchX2y();

  useEffect(() => {
    const xIds = options.map((o) => Number(o.value));
    getData(xIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.length, ...options]);
};
